










































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencyModule } from '@/store/modules/agency';
import CampaignDto from '@/models/Campaigns/CampaignDto';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import UpdateCampaignEmailDetailsRequest from '@/models/Campaigns/UpdateCampaignEmailDetailsRequest';
import ajax from '@/lib/ajax';
import { AppModule } from '@/store/modules/app';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';

@Component({
    name: 'CampaignEmailDetailsEdit'
})
export default class CampaignEmailDetailsEdit extends GiganautVueDialog {

  entity: CampaignDto = new CampaignDto();
  public editorKey = 0;
  public editorReady = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = JSON.parse(JSON.stringify(CampaignDetailsModule.currentCampaign));
      if (AgencySettingsModule.emailTemplates) {
        await AgencySettingsModule.getEmailTemplates();
      }
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get emailTemplates() {
    return AgencySettingsModule.emailTemplates;
  }

  get loading() {
    return CampaignDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const request = new UpdateCampaignEmailDetailsRequest()
    request.updatedAt = this.entity.updatedAt;
    if (this.entity.status === CampaignStatus.Draft) {
      request.emailTemplateId = this.entity.emailTemplate.id;
    }
    
    request.emailSubject = this.entity.emailSubject;
    request.emailFromName = this.entity.emailFromName;
    request.emailFromAddress = this.entity.emailFromAddress;
    request.emailMergeField1 = this.entity.emailMergeField1;
    request.emailMergeField2 = this.entity.emailMergeField2;
    request.emailMergeField3 = this.entity.emailMergeField3;
    request.emailMergeField4 = this.entity.emailMergeField4;
    request.emailMergeField5 = this.entity.emailMergeField5;
    request.isTest = this.entity.isTest;
    request.testEmailAddresses = this.entity.testEmailAddresses;
    await CampaignDetailsModule.editCampaignEmailDetails(request)
    this.dialog = false;
  }
}
